import createApi from 'api/createApi';

import i18n from 'utils/i18n';

export const tags = {
	app__dictionaries: 'mw/app/dictionaries',
};

export const appApi = createApi({
	reducerPath: 'mw/appApi',

	endpoints: (builder) => ({
		appDictionaries: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/app/dictionaries',
			}),
			providesTags: [tags.app__dictionaries],
			transformResponse(response) {
				i18n.addResourceBundle('uk', 'dictionary', response.result);

				return response;
			},
		}),
	}),
});

export const {
	appDictionaries,
} = appApi.endpoints;

export default appApi;